<template>
  <div class="main_form_box">
    <div class="main_form_bar">
      <div class="group_list_bar" v-show="!selectProjectGroupLoading">
        <span class="lable">请选择项目组：</span>
        <div
          v-for="item in projectGroupList"
          :key="item.Id"
          :class="{
            group_item_active: item.selected,
            group_item: !item.selected
          }"
          @click="groupClick(item.Id)"
        >
          <i
            style="margin-right: 0px"
            class="iconfont"
            :class="{
              'icon-duoxuan-yixuanze': item.selected,
              'icon-32duoxuanweixuanzhong': !item.selected
            }"
          ></i>
          {{ item.Name }}
        </div>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editProjectGroup(null)"
        >
          新增组
        </el-link>
      </div>
      <div class="group_list_bar" v-show="selectProjectGroupLoading">
        <span class="lable">
          <i class="el-icon-loading"></i>
          加载中…
        </span>
      </div>
      <div class="search_bar">
        <el-select
          v-model="projectSelectQuery.ProjectSelectType"
          size="mini"
          style="width: 100px"
          @change="changeProjectSelectType()"
        >
          <el-option label="奖项筛选" value="prize"> </el-option>
          <el-option label="排名筛选" value="ranking"> </el-option>
        </el-select>
      </div>
      <div class="search_bar">
        <el-select
          v-model="projectSelectQuery.SelectVoteIds"
          :multiple="projectSelectQuery.ProjectSelectType === 'prize'"
          collapse-tags
          size="mini"
          placeholder="请选择要筛选投票"
          :loading="selectPrizeVoteLoading"
          loading-text="加载中…"
          style="width: 160px"
          @change="changePriae()"
        >
          <el-option
            v-for="item in prizeVoteList"
            :key="item.Id"
            :label="item.VoteName"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search_bar">
        <!-- <el-checkbox
          v-model="projectSelectQuery.IsNoPrize"
          class="margin_right"
          :disabled="voteInfo.Status !== 0"
          @change="changeIsNoPrizeCheck()"
        >
          无奖项
        </el-checkbox> -->
        <el-select
          size="mini"
          v-model="projectSelectQuery.AwardStatus"
          @change="changeIsNoPrizeCheck()"
          v-if="projectSelectQuery.ProjectSelectType === 'prize'"
        >
          <el-option key="AwardStatus0" label="全部（有无奖项）" :value="0">
          </el-option>
          <el-option key="AwardStatus1" label="有奖项" :value="1"> </el-option>
          <el-option key="AwardStatus2" label="无奖项" :value="2"> </el-option>
        </el-select>
        <el-select
          v-model="projectSelectQuery.ProjectRankingNum"
          filterable
          allow-create
          default-first-option
          size="mini"
          @change="changeProjectRankingNum()"
          v-if="projectSelectQuery.ProjectSelectType === 'ranking'"
        >
          <el-option key="0" label="全部（前几名）" :value="0"> </el-option>
          <el-option :key="num" :label="num" :value="num" v-for="num in 20">
          </el-option>
        </el-select>
      </div>
      <el-button
        type="primary"
        size="mini"
        @click="searchProjects()"
        :disabled="voteInfo.Status !== 0"
        v-if="false"
      >
        查询
      </el-button>
    </div>
    <div class="main_form_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <el-button
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="exportTemplate()"
            :disabled="voteInfo.Status !== 0"
          >
            导出模板
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            size="mini"
            @click="importData()"
            :disabled="voteInfo.Status !== 0"
          >
            批量导入
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="editProject(null)"
            :disabled="voteInfo.Status !== 0"
          >
            新增项目
          </el-button>
          <span class="select_message margin_left_10 margin_right_10">
            已选（{{ selectRows.length }}）个项目
          </span>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">投票列表</el-button>
          <el-button
            type="primary"
            @click="editVoteProject(false)"
            size="small"
            :disabled="voteInfo.Status !== 0"
          >
            保存
          </el-button>
          <!-- <el-button
            type="primary"
            @click="editVoteProject(false)"
            size="small"
            :disabled="voteInfo.Status !== 0"
          >
            保存并开始投票
          </el-button> -->
          <el-button
            type="warning"
            size="small"
            @click="editVoteProject(true)"
            v-if="false"
          >
            完成
          </el-button>
        </div>
      </div>
      <div class="form_content" style="min-height: 500px">
        <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          :data="projectList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @cell-mouse-leave="leaveCall"
          @row-click="selectRowChange"
          stripe
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          >
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column property="ProjectName" label="项目名称">
          </el-table-column>
          <el-table-column
            property="ProjectGroupName"
            label="项目组名称"
            align="center"
          >
          </el-table-column>
          <el-table-column property="Remark" label="单位" align="center">
          </el-table-column>
          <el-table-column label="推荐信息" align="center">
            <template slot-scope="scope">
              <el-popover placement="right" width="450" trigger="click">
                <div
                  v-html="scope.row.Remark1"
                  style="overflow: auto; max-height: 450px"
                ></div>
                <div
                  v-html="scope.row.Remark1"
                  style="max-height: 60px; overflow: hidden"
                  slot="reference"
                ></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            property="Sort"
            :label="
              projectSelectQuery.ProjectSelectType === 'prize'
                ? '排序'
                : '原序号'
            "
            align="center"
          >
          </el-table-column>
          <el-table-column
            property="PrizeInfo"
            label="奖项"
            align="center"
            v-if="projectSelectQuery.ProjectSelectType === 'prize'"
          >
          </el-table-column>
          <el-table-column
            label="票数/排名/分数"
            align="center"
            v-if="
              projectSelectQuery.ProjectSelectType === 'ranking' &&
              projectSelectQuery.SelectVoteIds.length > 0
            "
          >
            <template slot-scope="scope">
              <span v-if="scope.row.VoteNum">{{ scope.row.VoteNum }}</span>
              <span v-if="scope.row.AllScore">{{ scope.row.AllScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            v-if="voteInfo.Status === 1 || voteInfo.Status === 3"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                v-if="scope.row.IsSelect"
                @click="deleteVoteProject(scope.row)"
              >
                移除
              </el-link>
              <el-link
                type="primary"
                v-if="!scope.row.IsSelect"
                @click="insertVoteProject(scope.row)"
              >
                添加
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <ImportExcel
          :fatherSubmitDialog="importExcelDialog"
          ref="importProject"
        ></ImportExcel>
        <EditProjectGroup
          :meetId="meetingId"
          :fatherSubmitDialog="editProjectGroupDialog"
          ref="editProjectGroup"
        ></EditProjectGroup>
        <EditProject
          :ProjectGroupID="projectSelectQuery.ProjectGroupIds[0]"
          :MeetingID="meetingId"
          :fatherSubmitDialog="editProjectDialog"
          ref="editProject"
        ></EditProject>
      </div>
    </div>
  </div>
</template>

<script>
import voteProjectApi from '../../../api/vote/voteProject'
import voteManageApi from '../../../api/vote/voteManage'
import ImportExcel from '@/components/project/ImportExcel.vue'
import EditProjectGroup from '@/components/project/EditProjectGroup.vue'
import EditProject from '@/components/project/EditProject.vue'
export default {
  name: 'EditVoteProject',
  components: {
    ImportExcel,
    EditProjectGroup,
    EditProject
  },
  data () {
    return {
      meetingId: null,
      selectProjectGroupLoading: true,
      projectGroupList: [],
      groupListQuery: {
        meetingId: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      selectPrizeVoteLoading: true,
      prizeVoteList: [],
      projectSelectQuery: {
        MeetingId: null,
        ProjectGroupIds: [],
        SelectVoteIds: [],
        // IsNoPrize: false
        AwardStatus: 0,
        ProjectRankingNum: 0,
        ProjectSelectType: 'prize'
      },
      projectList: [],
      tableLoading: false,
      selectRows: [],
      voteProjectInfo: {}
    }
  },
  props: ['voteInfo'],
  inject: ['voteCheck', 'getVoteInfo', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    changeProjectSelectType: function () {
      if (this.projectSelectQuery.ProjectSelectType === 'ranking') {
        this.projectSelectQuery.SelectVoteIds = []
        this.getNotEditVotes()
        this.searchProjects()
      }
      if (this.projectSelectQuery.ProjectSelectType === 'prize') {
        this.projectSelectQuery.SelectVoteIds = []
        this.getPrizeVotes()
        this.searchProjects()
      }
    },
    changePriae: function () {
      this.searchProjects()
    },
    changeIsNoPrizeCheck: function () {
      this.searchProjects()
    },
    changeProjectRankingNum: function () {
      this.searchProjects()
    },
    groupClick: function (groupId) {
      const _this = this
      _this.tableLoading = true
      let isAdd = true
      _this.projectSelectQuery.ProjectGroupIds.forEach(function (item, index) {
        if (item === groupId) {
          _this.projectSelectQuery.ProjectGroupIds.splice(index, 1)
          isAdd = false
        }
      })
      if (isAdd) {
        _this.projectSelectQuery.ProjectGroupIds.push(groupId)
      }
      _this.projectGroupList.forEach(function (item, index) {
        _this.$set(item, 'selected', false)
        _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
          if (item.Id === selectItem) {
            _this.$set(item, 'selected', true)
          }
        })
      })
      _this.searchProjects()
    },
    getDefaultProjectGroup: function () {
      const _this = this
      voteProjectApi.getDefaultProjectGroup({
        meetingId: _this.meetingId
      }).then(data => {
        if (!data) {
          _this.projectGroupList.unshift({ Id: null, Name: '默认组', Sort: 0 })
        }
        _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
          if (!selectItem) {
            _this.projectSelectQuery.ProjectGroupIds[index] = _this.projectGroupList[0].Id
          }
        })
        _this.projectGroupList.forEach(function (item, index) {
          _this.$set(item, 'selected', false)
          _this.projectSelectQuery.ProjectGroupIds.forEach(function (selectItem, index) {
            if (item.Id === selectItem) {
              _this.$set(item, 'selected', true)
            }
          })
        })
        this.getVoteProjectInfo()
        _this.selectProjectGroupLoading = false
      }).catch(err => {
        _this.selectProjectGroupLoading = false
        return err
      })
    },
    getProjectGroups: function () {
      const _this = this
      _this.selectProjectGroupLoading = true
      voteProjectApi.getProjectGroups(_this.groupListQuery).then(data => {
        _this.projectGroupList = data.Items
        _this.getDefaultProjectGroup()
      }).catch(err => {
        _this.selectProjectGroupLoading = false
        return err
      })
    },
    getPrizeVotes: function () {
      this.selectPrizeVoteLoading = true
      voteManageApi.getPrizeVotes({ meetingId: this.$route.params.mid }).then(data => {
        this.prizeVoteList = data
        this.selectPrizeVoteLoading = false
      }).catch(err => {
        this.selectPrizeVoteLoading = false
        return err
      })
    },
    getNotEditVotes: function () {
      this.selectPrizeVoteLoading = true
      voteManageApi.getNotEditVotes({ meetingId: this.$route.params.mid }).then(data => {
        this.prizeVoteList = data
        this.selectPrizeVoteLoading = false
      }).catch(err => {
        this.selectPrizeVoteLoading = false
        return err
      })
    },
    searchProjects: function () {
      const _this = this
      _this.tableLoading = true
      voteProjectApi.getProjectSelectList(_this.projectSelectQuery).then(data => {
        this.projectList = data
        this.$nextTick(() => {
          _this.projectList.forEach(function (row, index) {
            _this.$set(row, 'IsSelect', false)
            _this.voteProjectInfo.ProjectIds.forEach(function (selectItem, index) {
              if (row.ProjectId.toLowerCase() === selectItem.toLowerCase()) {
                _this.$refs.multipleTable.toggleRowSelection(row, true)
                _this.$set(row, 'IsSelect', true)
              }
            })
          })
        })
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      if (column && column.label === '操作') {
        return
      }
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    checkSelectable: function (row) {
      if (this.voteInfo.Status !== 0) {
        return false
      } else {
        return true
      }
    },
    getVoteProjectInfo: function () {
      const _this = this
      _this.tableLoading = true
      voteManageApi.getVoteProjectInfo({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteProjectInfo = data
        _this.searchProjects()
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    editVoteProject: function (isNext) {
      const _this = this
      const openLoading = _this.openLoading('保存中…')
      const selectIds = []
      this.selectRows.map(item => {
        selectIds.push(item.ProjectId)
      })
      this.voteProjectInfo = {
        Id: this.$route.params.vid,
        SelectNumber: this.selectRows.length,
        SelectProjectNum: this.selectRows.length,
        SmallSelectNumber: this.selectRows.length,
        ProjectIds: selectIds
      }
      voteManageApi.editVoteProject(this.voteProjectInfo).then(data => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功!'
        })
        if (isNext) {
          _this.$router.push({
            name: 'editVoteSetting',
            params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid }
          })
        }
      }).catch(err => {
        // _this.$root.$emit('voteCheck')
        this.voteCheck()
        openLoading.close()
        return err
      })
    },
    projectGroupManager: function () {
      this.$router.push({ name: 'voteProjectGroup', params: { mid: this.$route.params.mid, vid: this.$route.params.vid } })
    },
    importData: function () {
      if (this.projectSelectQuery.ProjectGroupIds.length > 1) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '导入待评项只能指定一个项目组！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 0) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '请选择项目组再导入待评项！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 1) {
        let projectGroupId = null
        projectGroupId = this.projectSelectQuery.ProjectGroupIds[0]
        this.$refs.importProject.openImportExcel(projectGroupId, this.$route.params.mid)
      }
    },
    importExcelDialog: function (projectGroupID) {
      this.getProjectGroups()
      // this.getVoteProjectInfo()
    },
    editProjectGroup: function (projectGroupID) {
      this.$refs.editProjectGroup.openEditProjectGroup(projectGroupID)
    },
    editProjectGroupDialog: function () {
      this.getProjectGroups()
    },
    exportTemplate: function () {
      const _this = this
      let projectGroupId = null
      if (_this.projectSelectQuery.ProjectGroupIds.length > 0) {
        projectGroupId = _this.projectSelectQuery.ProjectGroupIds[0]
      }
      const openLoading = _this.openLoading()
      voteProjectApi.exportProjectTemplate({
        MeetingId: _this.$route.params.mid,
        ProjectGroupId: projectGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '待评项目'
        if (projectGroupId) {
          _this.projectGroupList.forEach(function (item, index) {
            if (item.Id === projectGroupId) {
              fileName = item.Name
            }
          })
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xls')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    editProject: function (projectId) {
      if (this.projectSelectQuery.ProjectGroupIds.length > 1) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '新增待评项只能指定一个项目组！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 0) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '请选择项目组再新增待评项！'
        })
      }
      if (this.projectSelectQuery.ProjectGroupIds.length === 1) {
        this.$refs.editProject.openEditProject(projectId)
      }
    },
    editProjectDialog: function () {
      this.getProjectGroups()
      // this.getVoteProjectInfo()
    },
    deleteVoteProject: function (row) {
      const _this = this
      this.$confirm('确认是否删除待评项：' + row.ProjectName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.adjustVoteProject({
          VoteId: _this.$route.params.vid,
          ProjectId: row.ProjectId,
          Action: 'Delete'
        }).then(data => {
          _this.getVoteProjectInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    insertVoteProject: function (row) {
      const _this = this
      this.$confirm('确认是否添加待评项：' + row.ProjectName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.adjustVoteProject({
          VoteId: _this.$route.params.vid,
          ProjectId: row.ProjectId,
          Action: 'Insert'
        }).then(data => {
          _this.getVoteProjectInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    }
  },
  created () {
    this.meetingId = this.$route.params.mid
    this.groupListQuery.meetingId = this.$route.params.mid
    this.projectSelectQuery.MeetingId = this.$route.params.mid
    this.getProjectGroups()
    if (this.voteInfo.VoteType !== undefined) {
      if (this.voteInfo.VoteType === 0 && this.voteInfo.IsScreen) {
        this.projectSelectQuery.ProjectSelectType = 'ranking'
        this.projectSelectQuery.SelectVoteIds = []
        this.getNotEditVotes()
      } else {
        this.projectSelectQuery.ProjectSelectType = 'prize'
        this.projectSelectQuery.SelectVoteIds = []
        this.getPrizeVotes()
      }
    }
    // this.getVoteProjectInfo()
    // this.$root.$emit('routeChange')
    this.routeChange()
    // this.$root.$emit('voteCheck')
    this.voteCheck()
  },
  watch: {
    voteInfo: {
      handler (val) {
        if (this.voteInfo.VoteType === 0 && this.voteInfo.IsScreen) {
          this.projectSelectQuery.ProjectSelectType = 'ranking'
          this.projectSelectQuery.SelectVoteIds = []
          this.getNotEditVotes()
        } else {
          this.projectSelectQuery.ProjectSelectType = 'prize'
          this.projectSelectQuery.SelectVoteIds = []
          this.getPrizeVotes()
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less">
.search_bar .el-select__tags-text {
  display: inline-block;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search_bar .el-select .el-tag__close.el-icon-close {
  top: -7px;
}
</style>
